import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { EventService } from 'app/shared/event.service';
import { Injectable } from '@angular/core';

@Injectable()
export class GuidInterceptor implements HttpInterceptor {
  constructor(private eventService: EventService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do((res: HttpEvent<any>) => {
      //console.log('GUID: ----->>>>' + req);
      if (res instanceof HttpResponse && res.body && res.body.responseContext) {
        this.eventService.publish('GUID', res.body.responseContext.guid);
        //console.log('GUID Res: ----->>>>' + res.body.responseContext.guid);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/footer/guid-interceptor.ts